import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import * as ClassicEditor from 'src/assets/ckeditor/build/ckeditor';
import { CustomTemplatesService } from '../custom-templates.service';
@Component({
  selector: 'app-template4',
  templateUrl: './template4.component.html',
  styleUrls: ['./template4.component.css']
})
export class Template4Component implements OnInit {
  public imagearray1 = ['assets/images/download.jpg', 'assets/images/download.jpg', 'assets/images/download.jpg'];

  public array = ["assets/templateimages/meeting_Artboard (1).png", "assets/templateimages/jaldeevideo.34da709d24c020f7f0f4 (1).jpg", "assets/templateimages/b5757a2eed2300820433e4083ae635c2.jpg", "assets/templateimages/meeting_Artboard (1).png", "assets/templateimages/jaldeevideo.34da709d24c020f7f0f4 (1).jpg", "assets/templateimages/meeting_Artboard (1).png"];
  public departments = ['healthcare', 'clinic', 'dental', 'medical', 'ortho', 'babydocktor'];

  public publishvarible = false;
  public Editor = ClassicEditor;
  public editorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'fontSize',
        'fontColor',
        'subscript',
        'superscript',
        '|',
        'alignment',
        'bulletedList',
        'numberedList',
        'indent',
        'outdent',
        'specialCharacters',
        '|',
        'link',
        'blockQuote',
        'insertTable',
        'mediaEmbed',
        'undo',
        'redo'
      ]
    },
    colorButton_colors: '008000,454545,FFF',
    colorButton_enableMore: 'False',
    language: 'en',
    image: {
      toolbar: [
        'imageTextAlternative',
        'imageStyle:full',
        'imageStyle:side'
      ]
    },
    table: {
      contentToolbar: [
        'tableColumn',
        'tableRow',
        'mergeTableCells',
        'tableCellProperties',
        'tableProperties'
      ]
    },

  };
  loading = true;
  templateForm: any;
  accountDetails: any;
  templateJson: any;
  loginRequired = false;
  public loader = false;
  public data: any = []
  branchFilterUser = false;
  branchFilterService = false;

  themes = projectConstants.THEMES;
  selectedTheme="";

  section1  =  {
    title: 'Tab1',
    generalDescription: 'General Description',
    appointments: false,
    appointmentsDescription: 'Add appointments description here',
    checkins: false,
    checkinsDescription: 'Add checkins description here',
    orders: false,
    ordersDescription: 'Add orders description here',
    donations: false,
    donationsDescription:'Add donations description here',
    departments: false,
    departmentDescription: 'Add department description here',
    gallery: false,
    galleryDescription: 'Add gallery description here',
    users: false,
    usersDescription: 'Add users description here'
  }
  section2  =  {
    title: 'Tab2',
    generalDescription: 'General Description',
    appointments: false,
    appointmentsDescription: 'Add appointments description here',
    checkins: false,
    checkinsDescription: 'Add checkins description here',
    orders: false,
    ordersDescription: 'Add orders description here',
    donations: false,
    donationsDescription:'Add donations description here',
    departments: false,
    departmentDescription: 'Add department description here',
    gallery: false,
    galleryDescription: 'Add gallery description here',
    users: false,
    usersDescription: 'Add users description here'
  }
  section3  =  {
    title: 'Tab3',
    generalDescription: 'General Description',
    appointments: false,
    appointmentsDescription: 'Add appointments description here',
    checkins: false,
    checkinsDescription: 'Add checkins description here',
    orders: false,
    ordersDescription: 'Add orders description here',
    donations: false,
    donationsDescription: 'Add donations description here',
    departments: false,
    departmentDescription: 'Add department description here',
    gallery: false,
    galleryDescription: 'Add gallery description here',
    users: false,
    usersDescription: 'Add users description here'
  }


  constructor(private fb: UntypedFormBuilder,
    private activated_route: ActivatedRoute,
    private templateService: CustomTemplatesService) { }
  ngOnInit(): void {
    this.accountDetails = this.activated_route.parent.snapshot.data['accountDetails'];
    console.log(this.accountDetails);
    this.templateForm = this.fb.group({
      headerTitle: new UntypedFormControl('Welcome to Hawk hospital'),
      headerDescription: new UntypedFormControl('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu sem tempor, varius quam at, luctus dui. Mauris magna metus, dapibus nec turpis vel, semper malesuada ante. Idac bibendum scelerisque non non purus. Suspendisse varius nibh non aliquet.'),
    })
    this.loader = true;
    const url = projectConstants.UIS3PATH + this.accountDetails.account.uniqueId + "/template.json?" + new Date();
    console.log(url);
    this.templateService.getTemplateJson(url).then(
      (template) => {
        if (template) {
          if (template['template'] === 'template4') {
            this.templateJson = template;
            this.setTemplateValues(template);
          } else {
            this.templateJson = {
              template: 'template3',
              logo: 'assets/images/download.jpg',
              coverPicture: 'assets/images/download.jpg'
            };
          }
          this.loading = false;
        } else {
          this.templateJson = {
            logo: 'assets/images/download.jpg',
            coverPicture: 'assets/images/download.jpg'
          };
          this.loading = false;
        }
      }, () => {
        this.templateJson = {
          logo: 'assets/images/download.jpg',
          coverPicture: 'assets/images/download.jpg'
        };
        this.loading = false;
      }
    )
    console.log('json working', this.data)
  }

  setTemplateValues(template) {
    console.log('setTemplateValues');
    console.log(template);
    this.templateForm.patchValue({
      headerTitle: template.headerTitle,
      headerDescription: template.headerDescription
    });
    this.section1 = template.section1;
    this.section2 = template.section2;
    this.section3 = template.section3;
    this.selectedTheme = template.theme;
    if(template.loginRequired) {
      this.loginRequired = template.loginRequired;
    }
  }

  changeTheme(theme) {
    this.selectedTheme = theme.value;
  }

  publishTemplate() {
    const _this = this;
    console.log('publishTemplate');
    console.log(this.templateForm.value);
    this.setTemplateJson(this.templateForm.value);
    this.publishvarible = true;
    console.log("here");
    console.log(this.templateJson);
    //here we should a rest url for save the templatejson
    this.templateService.publish(this.templateJson, this.accountDetails.account.id);
  }
  edit() {
    this.publishvarible = false;
  }
  // selectFile(event, i, j) {
  //   console.log('i==================', i, "j=========", j);
  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0]
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       if (i === "headimage") {
  //         this.templateJson['headerImage'] = event.target.result;
  //       } else if (i === "section2Image") {
  //         this.templateJson['section2Image'] = event.target.result;
  //       } else if (i === "newsfeed") {
  //         this.templateForm.value.newsfeeds[j].image = event.target.result;
  //       } else {
  //         this.templateForm.value.section1Images[i] = event.target.result;
  //       }
  //     }
  //     reader.readAsDataURL(file);
  //   }
  // }
  selectFile(event, i, j) {
    console.log('i==================', i, "j=========", j);
    if (event.target.files.length > 0) {
      const file = event.target.files[0]
      var reader = new FileReader();
      reader.onload = (event: any) => {
        if (i === "headimage") {
          this.templateJson['headerImage'] = event.target.result;
        } else if (i === "section2Image") {
          this.templateJson['section2Image'] = event.target.result;
        } else if (i === "newsfeed") {
          this.templateForm.value.newsfeeds[j].image = event.target.result;
        } else if (i === "coverpic") {
          this.templateJson['coverPicture']=event.target.result;
        } else if (i === "logo") {
          this.templateJson['logo']=event.target.result;
        } else {
          this.templateForm.value.section1Images[i] = event.target.result;
        }
      }
      reader.readAsDataURL(file);
    }
  }
  setTemplateJson(template) {
    this.templateJson['template'] = "template4";
      this.templateJson['theme'] = this.selectedTheme;
    this.templateJson['headerTitle'] = template.headerTitle;
    this.templateJson['headerDescription'] = template.headerDescription;
    this.templateJson['section1Title'] = template.section1Title;
    this.templateJson['section1Appointments'] = template.section1Images;
    this.templateJson['section1Description'] = template.section1Description;
    this.templateJson['section2Title'] = template.section2Title;
    this.templateJson['section2Description'] = template.section2Description;
    this.templateJson['branchFilterUser'] = this.branchFilterUser;
    this.templateJson['branchFilterService'] = this.branchFilterService;
    this.templateJson['section1'] = this.section1;
    this.templateJson['section2'] = this.section2;
    this.templateJson['section3'] = this.section3;
    this.templateJson['loginRequired']= this.loginRequired;
    // this.templateJson['locationFilterUser'] = this.locationFilterUser;
    // this.templateJson['locationFilterService'] = this.locationFilterService;
    // this.templateJson['showRecentNews'] = this.showRecentNews;
  }
  // setTemplateJson(template) {
  //   this.templateJson['template'] = "template4";
  //   this.templateJson['theme'] = '';
  //   this.templateJson['headerTitle'] = template.headerTitle;
  //   this.templateJson['headerDescription'] = template.headerDescription;
  //   this.templateJson['section1Title'] = template.section1Title;
  //   this.templateJson['section1Images'] = template.section1Images;
  //   this.templateJson['section1Description'] = template.section1Description;
  //   this.templateJson['section2Title'] = template.section2Title;
  //   this.templateJson['section2Description'] = template.section2Description;
  //   this.templateJson['section3Title'] = template.section3Title;
  //   this.templateJson['section3Description'] = template.section3Description;
  //   this.templateJson['section4Title'] = template.section4Title;
  //   this.templateJson['section4Description'] = template.section4Description;
  //   this.templateJson['section5Title'] = template.section5Title;
  //   this.templateJson['section5Description'] = template.section5Description;
  //   // this.templateJson['showSection3'] = this.showSection3;
  //   // this.templateJson['showSection4'] = this.showSection4;
  //   this.templateJson['branchFilterUser'] = this.branchFilterUser;
  //   this.templateJson['branchFilterService'] = this.branchFilterService;
  //   this.templateJson['appointments'] = true;
  //   this.templateJson['checkins'] = true;
  //   this.templateJson['donations'] = true;
  //   this.templateJson['orders'] = true;
  //   // this.templateJson['locationFilterUser'] = this.locationFilterUser;
  //   // this.templateJson['locationFilterService'] = this.locationFilterService;
  //   // this.templateJson['showRecentNews'] = this.showRecentNews;
  // }
}